import React from "react";
import PropTypes from "prop-types";
import styles from "components/settings/subscription-settings.scss";
import { planDetailsType } from "custom-prop-types";
import { Button } from "components/common/button";

export const Plans = (props) => (
  <div className={ styles["rendered-plans"] }>
    {monthlyOrAnnualPlans(props)}
  </div>
);

Plans.propTypes = {
  annualPlans: PropTypes.arrayOf(planDetailsType).isRequired,
  monthlyPlans: PropTypes.arrayOf(planDetailsType).isRequired,
  planDetails: planDetailsType.isRequired
};

const monthlyOrAnnualPlans = (props) => {
  if (props.planDisplay === "monthly") {
    return mapPlans(props, props.monthlyPlans);
  }
  return mapPlans(props, props.annualPlans, true);
};

const mapPlans = ({
  planDetails,
  onShowUpgradeDowngrade,
  onUpdatePlan,
  accountId,
  isChangePlanLoading
}, plans, isAnnual = false) => (
  plans.map((plan) => (
    <IndividualPlan
      accountId={ accountId }
      isAnnual={ isAnnual }
      isChangePlanLoading={ isChangePlanLoading }
      key={ `${plan.planType}${plan.subscriptionType}` }
      onShowUpgradeDowngrade={ onShowUpgradeDowngrade }
      onUpdatePlan={ onUpdatePlan }
      plan={ plan }
      planDetails={ planDetails }
    />
  ))
);

const IndividualPlan = ({
  isAnnual,
  onShowUpgradeDowngrade,
  plan,
  planDetails
}) => {
  const activePlanStyle = activePlan(planDetails, plan);
  return (
    <div className={ `${styles[activePlanStyle]} ${styles.plan}` }>
      <div className={ `${styles.title} ${styles.grid}` }>
        <div className={ styles.name }>{ plan.planName }</div>
      </div>
      <div className={ `${styles.price} ${styles.grid}` }>
        <div>{ priceForMonthlyOrAnnual(isAnnual, plan) }</div>
        <div className={ styles.per }>{ scheduleForBilling(isAnnual, plan) }</div>
      </div>
      <div className={ `${styles.cell} ${styles.grid}` }>
        <strong>{ plan.documentLimitPerMonth }</strong> documents / month
      </div>
      <div className={ `${styles.cell} ${styles.grid}` }>
        { plan.includesPrepaidEnvelopes ? "Prepaid Magic Envelopes" : "Digital only" }
      </div>
      <div className={ `${styles.turnaround} ${styles.grid}` }>
        { displayTurnaroundTime(plan) }
        <div className={ styles.button }>
          <Button onClick={ () => onShowUpgradeDowngrade(plan) } primary>
            { upgradeOrDowngrade(plan, planDetails) }
          </Button>
        </div>
      </div>
    </div>
  );
};

IndividualPlan.propTypes = {
  isAnnual: PropTypes.bool.isRequired,
  onShowUpgradeDowngrade: PropTypes.func.isRequired,
  plan: planDetailsType.isRequired,
  planDetails: planDetailsType.isRequired
};


const activePlan = (planDetails, plan) => {
  if (planDetails.planType === plan.planName && planDetails.subscriptionType === plan.subscriptionType) {
    return "active";
  }
  return "column";
};

const priceForMonthlyOrAnnual = (isAnnual, plan) => {
  if (isAnnual) {
    const price = (parseFloat(plan.defaultPrice) / 12).toFixed(2);
    return price === "0.00" ? "Free" : `$${price}`;
  }
  return plan.defaultPrice === "0.0" ? "Free" : `$${plan.defaultPrice}`;
};

const scheduleForBilling = (isAnnual, plan) => {
  if (isAnnual) {
    return plan.planName === "DIY" ? " " : "Per Month, billed annually";
  }
  return plan.planName === "DIY" ? " " : "Per Month";
};

const displayTurnaroundTime = (plan) => {
  if (plan.planType === "DIY") {
    return "3-5 day turnaround";
  }
  if (plan.targetTurnaroundMinDays === plan.targetTurnaroundMaxDays) {
    return `${plan.targetTurnaroundMaxDays} day turnaround`;
  }
  return `${plan.targetTurnaroundMinDays}-${plan.targetTurnaroundMaxDays} day turnaround`;
};

const upgradeOrDowngrade = (plan, planDetails) => {
  if (plan.documentLimitPerMonth > planDetails.documentLimitPerMonth) {
    return "Upgrade";
  }
  return "Downgrade";
};



// WEBPACK FOOTER //
// ./src/js/components/settings/plans.jsx